import Cards from "../../cards/Cards";
import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import BtnAcessoRapido from "../../AcessoRapido/BtnAcessoRapido";
import "./Dashboard.css";
import React, { useEffect, useState } from "react";
import DadosBacarios from "../../cards/DadosBacarios";
import PerformaceVendas from "../../cards/PerformaceVendas";
import ValorCard from "../../cards/ValorCard";
import Api from "../../Services/Api";
import ExtratoResumo from "../Extrato/ExtratoResumo";

const Dashboard = () => {
  const [menuClose, setMenuClose] = useState(false);
  const toggleMenu = () => setMenuClose((prev) => !prev);

  const [extratoResumo, setExtratoResumo] = useState([]);

  useEffect(() => {
    Api.get("/ledger-entries/me/summary")
      .then((res) => setExtratoResumo(res.data || []))
      .catch((err) => console.error("Erro ao carregar resumo do extrato", err));
  }, []);

  return (
    <div className="app-container">
      <Sidebar close={menuClose} dashboardActive="active" />

      <main className="main-content">
        <Topbar page="Dashboard / Tela Inicial" onToggleMenu={toggleMenu} />

        <Cards>
          <DadosBacarios />
          <PerformaceVendas />
          <ValorCard />
        </Cards>

        <BtnAcessoRapido icone="➕" text="Cadastrar novos leads" />

        <ExtratoResumo itensLista={extratoResumo} />
      </main>
    </div>
  );
};

export default Dashboard;
